<template>
  <BaseCard :heading="t('register.invoice.refund_method')">
    <Flex direction="column">
      <BaseTable
        v-test="'refund-sale-table'"
        v-model="selectedItems"
        :headers="[
          t('global.items.item', 2),
          t('global.employee'),
          t('global.quantity'),
          {
            value: t('global.price'),
            type: 'currency',
            alignRight: true,
          },
          {
            value: t('global.amount'),
            type: 'currency',
            alignRight: true,
          }
        ]"
        :rows="
          items.map((item) => ({
            id: item.id,
            cells: [
              item.description || '',
              item.employee?.name || '',
              item.quantity ?? '',
              {
                value: filters.currency(item.price ?? 0),
                type: 'currency',
                alignRight: true,
              },
              {
                value: filters.currency(itemLineTotal(item)),
                type: 'currency',
                alignRight: true,
              }
            ],
          })) || []
        "
      />
      <Totals :order="order" />
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed, inject, type Ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import type { Order } from '@/types';
import Totals from './Totals.vue';
import { itemLineTotal, refundableItems } from './utils';

const props = defineProps<{
  order?: Order | null;
}>();

const { t } = useI18n();

const selectedItems = inject<Ref<string[]>>('selectedItems');

const items = computed(() => refundableItems(props.order?.items));

watch(
  items,
  (items) => {
    selectedItems.value = items.map((item) => item.id);
  },
  { immediate: true },
);
</script>
